<template>
  <div>
    <template v-if="vr_company_balance === true">
<!--      <div v-show="isDataTableLoading === false">-->
        <div class="page-top mb-1 mb-3 align-left clearfix row">
          <div class="col">
          <h1> Virtual Company Balances</h1>
          </div>
          <div class="col">
            <h2>Total Virtual Company Balance : RS. {{new Intl.NumberFormat().format(totalCompanyBalance)}}</h2>
          </div>
        </div>
        <div class="page-top mb-1 mb-3 clearfix">
          <button @click="downloadExcel"  class="btn btn-primary">Download Excel</button>
          <div class="tab-pane fade show active" id="processed" role="tabpanel" aria-labelledby="processed-tab">
            <table id="companyBalances" class="table" style="width:100%">
              <thead>
              <tr>
                <th>Company</th>
                <th>Wallet ID</th>
                <th style="display:none;">IBAN</th>
                <th>Balance</th>

              </tr>
              </thead>
            </table>
          </div>
        </div>
<!--      <preLoader v-show="isDataTableLoading === true"></preLoader>-->
    </template>

    <template v-else-if="vr_company_balance === false">
      <notAllowed></notAllowed>
    </template>

    <template v-else-if="vr_company_balance === null">
      <preLoader></preLoader>
    </template>
  </div>
</template>
<script>
var gThat = null;
export default {
  data() {
    return {
      data: null,
      vr_company_balance: null,
      currentActiveTab : 'processed',
      totalCompanyBalance : '',
      // isDataTableLoading : false,
      processtab : null,
      errortab : null,
    };
  },
  mounted() {
    gThat = this;
    this.$Progress.start();
    this.can('transfer_in').then(result => {
      this.vr_company_balance = result.transfer_in;
    }).then(result => {
      if(this.vr_company_balance == true){
        this.totalVRCompanyBalance();
        this.vrCompanyBalances();
        this.$Progress.finish();
      }else{
        this.$Progress.finish();
      }
    });
  },

  methods: {
    totalVRCompanyBalance: function (){
      this.$Progress.start();
      axios.get('/api/getTotalVRCompanyBalance')
          .then(res => {
            if(res.status == 200){
              this.totalCompanyBalance = res.data;
              this.$Progress.finish();
            }else{
              this.$Progress.fail();
              this.showAlertBox('error','Some error occured');
            }
          }).catch(err => {
            $(this.$el).find('.selectpicker').selectpicker('refresh');
            this.showAlertBox('error','Some error occured');
          });
    },
    vrCompanyBalances: function () {
      var self = this;
      this.processtab = $("#companyBalances").DataTable({
        processing: true,
        serverSide: true,
        responsive: true,
        ordering: false,
        ajax: {
          url: "api/vrCompanyBalanceData",
          method: "get",
        }, columns: [
          {data: "name"},
          {data: "walletID"},
          // {data: "iban"},
          {data: "currentBalance"},
        ],
      });
    },
    downloadExcel: function(id){
      this.$Progress.start();
      var formData = {
        'companyCount': '',
      }
      axios.post('/api/downloadVRCompanyBalancesExcel',formData,{
        responseType: 'blob'
      })
          .then((response) => {
            if(response.status == 200){
              this.$Progress.finish();
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'vr_company_balances.xlsx')
              document.body.appendChild(link)
              link.click()
              this.$Progress.finish();
            }else{
              this.showAlertBox('error','There is some problem');
            }

          }).catch(err => {
        console.log(err);
        this.$Progress.fail();
        this.showAlertBox('error','There is some problem');
      });
    }

  },
};
</script>
